import { GET, POST, DELETE, PATCH, PUT } from "request/service";

export const login = async (params: any) => {
  return await GET(`/auth/code/login`, { params });
};

export const getLayer = async () => {
  return await GET(`/risklayer-api/catnet-cn/layers`);
};

export const getCrsLayer = async () => {
  return await GET(`/risklayer-api/crs/riskTypeList`);
};

export const getFutureHazardLayer = async () => {
  return await GET(`/risklayer-api/futurehazard/riskTypeList`);
};

export const getCrsComponentLayer = async () => {
  return await GET(`/risklayer-api/crscomponent/riskTypeList`);
};

export const getLegend = async (layerID: string) => {
  return await GET(`/risklayer-api/catnet-cn/layers/${layerID}/legend`);
};

export const getLegends = async (params: any) => {
  return await GET(`/risklayer-api/catnet-cn/legends`, { params });
};

export const getAnalysis = async (params: any) => {
  return await GET(`/risklayer-api/catnet/layersAnalysis/analysis`, { params });
};

export const getStartAnalysis = async (params: any) => {
  return await POST(`/singlesite-api/riskAnalysis/startAnalysis`, params);
};

// export const getCrsAnalysisResult = async (batchId: string) => {
//   return await GET(`/risklayer-api/crs/lookup/${batchId}`);
// };

// export const getFutureHazardAnalysisResult = async (batchId: string) => {
//   return await GET(`/risklayer-api/futurehazard/lookup/${batchId}`);
// };

// export const getCrsComponentAnalysisResult = async (batchId: string) => {
//   return await GET(`/risklayer-api/crscomponent/lookup/${batchId}`);
// };

export const getCrsAnalysisResult = async (batchId: string) => {
  return await GET(`/singlesite-api/riskAnalysis/getCrsAnalysisResult?batchId=${batchId}`);
};

export const getFutureHazardAnalysisResult = async (batchId: string) => {
  return await GET(`/singlesite-api/riskAnalysis/getFutureHazardAnalysisResult?batchId=${batchId}`);
};

export const getCrsComponentAnalysisResult = async (batchId: string) => {
  return await GET(`/singlesite-api/riskAnalysis/getCrsComponentAnalysisResult?batchId=${batchId}`);
};

export const getAmapGeo = async (params: any) => {
  return await GET(`/risklayer-api/amap/geo`, { params });
};

export const getAmapPlaceText = async (params: any) => {
  return await GET(`/risklayer-api/amap/placeText`, { params });
};

export const getAmapRegeo = async (params: any) => {
  return await GET(`/risklayer-api/amap/regeo`, { params });
};

export const downloadReport = async (params: any) => {
  return await POST(`/singlesite-api/report/exportReportPdf`, params, { responseType: "blob" });
};

export const downloadHazardPdf = async (params: any) => {
  return await POST(`/data-report/hazard/dl`, params, { responseType: "blob" });
};

export const getAuth = async () => {
  return await POST(`/auth/user/authorizeOnce`);
};

export const logout = async () => {
  return await POST(`/auth/user/logout`);
};

export const agreement = async () => {
  return await POST(`/auth/user/sign`);
};

export const downloadClimatePdf = async (params: any) => {
  return await POST(`/data-report/climate/dl`, params, { responseType: "blob" });
};

export const downloadClimateJodPdf = async (params: any) => {
  return await POST(`/data-report/climate/jod/dl`, params, { responseType: "blob" });
};

export const getLocationsets = async () => {
  return await GET(`/locationset-api/manage/locationsets`);
};

export const addLocationsets = async (params: any) => {
  return await POST(`/locationset-api/manage/locationsets`, params);
};

export const deleteLocationsets = async (id: any) => {
  return await DELETE(`/locationset-api/manage/locationsets/${id}`);
};

export const patchLocationsets = async (id: any, params: any) => {
  return await PATCH(`/locationset-api/manage/locationsets/${id}`, params);
};

export const getLocationsetsItems = async (id: any) => {
  return await GET(`/locationset-api/manage/locationsets/${id}`);
};

export const addLocationSetItems = async (id: any, params: any) => {
  return await POST(`/locationset-api/manage/locationsets/${id}/items`, params);
};

export const deleteLocationsetsItems = async (locationSetId: any, locationId: any) => {
  return await DELETE(`/locationset-api/manage/locationsets/${locationSetId}/items/${locationId}`);
};

export const patchLocationsetsItems = async (locationSetId: any, locationId: any, params: any) => {
  return await PATCH(`/locationset-api/manage/locationsets/${locationSetId}/items/${locationId}`, params);
};

export const startMultipleAnalysis = async (params: any) => {
  return await POST(`/locationset-api/asyncBatchJob/createMultipleChunks`, params);
};

export const batchGeo = async (params: any) => {
  return await POST(`/locationset-api/amap/batchGeo`, params);
};

export const batchGeoStatus = async (params: any) => {
  return await GET(`/locationset-api/amap/batchGeoStatus`, { params });
};

export const batchGeoResult = async (params: any) => {
  return await GET(`/locationset-api/amap/batchGeoResult`, { params });
};

export const getMultipleAnalysisStatus = async (jobId: string) => {
  return await GET(`/locationset-api/asyncBatchJob/checkStatus/${jobId}`);
};

export const getMultipleAnalysisResult = async (jobId: string, tabIndex: string) => {
  return await GET(`/locationset-api/asyncBatchJob/getApiResponseResultByTabId/${jobId}/TabGroup/${tabIndex}`);
};

export const getTenant = async (param: any, pageParam: any) => {
  return await POST(`/admin-api/system/tenant/listPage`, param, { params: pageParam });
};

export const addTenant = async (params: any) => {
  return await POST(`/admin-api/system/tenant/addTenant`, params);
};

export const updateTenant = async (params: any) => {
  return await POST(`/admin-api/system/tenant/update`, params);
};

export const removeTenant = async (id: any) => {
  return await GET(`/admin-api/system/tenant/remove/${id}`);
};

export const getTenantAllData = async () => {
  return await GET(`/admin-api/system/tenant/list`);
};

export const getRoleDataByTenant = async (params: any) => {
  return await GET(`/admin-api/system/role/listByTenantId`, { params });
};

export const getRoleData = async () => {
  return await GET(`/admin-api/system/role/list`);
};

export const getUserData = async (data: any, params: any) => {
  return await POST(`/admin-api/system/user/listUserPage`, data, { params });
};

export const addUserData = async (params: any) => {
  return await POST(`/admin-api/system/user/addUser`, params);
};

export const deleteUserData = async (params: any) => {
  return await POST(`/admin-api/system/user/batchDelete`, params);
};

export const editUserData = async (params: any) => {
  return await POST(`/admin-api/system/user/update`, params);
};

export const editBatchUserData = async (params: any) => {
  return await POST(`/admin-api/system/user/batchUpdate`, params);
};

export const importRecords = async (params: any) => {
  return await POST(`/admin-api/idaas/login-log/importDataByExcel`, params);
};

export const getLoginLogData = async (params: any) => {
  return await GET(`/admin-api/idaas/login-log/listPage`, { params });
};

export const getstatLoginCountData = async (params: any) => {
  return await GET(`/admin-api/idaas/login-log/statPageLoginCount`, { params });
};

export const downloadUserData = async (data: any) => {
  return await POST(`/admin-api/system/user/exportUserList?${new URLSearchParams(data).toString()}`, data, { responseType: "blob" });
};

export const downloadTenantData = async (data: any) => {
  return await POST(`/admin-api/system/tenant/exportTenantList?${new URLSearchParams(data).toString()}`, data, { responseType: "blob" });
};

export const downloadLoginStatistic = async (data: any) => {
  return await POST(`/admin-api/idaas/login-log/exportLoginStatistic?${new URLSearchParams(data).toString()}`, data, { responseType: "blob" });
};

export const downloadLoginList = async (data: any) => {
  return await POST(`/admin-api/idaas/login-log/exportLoginList?${new URLSearchParams(data).toString()}`, data, { responseType: "blob" });
};

export const batchUpdateWithNotMatch = async () => {
  return await GET(`/admin-api/idaas/login-log/batchUpdateWithNotMatch`);
};

export const deleteRecords = async (params: any) => {
  return await POST(`/admin-api/idaas/login-log/removeByIds`, params);
};

export const getRole = async (param: any, pageParam: any) => {
  return await POST(`/admin-api/system/role/listPage`, param, { params: pageParam });
};

export const addRole = async (param: any) => {
  return await POST(`/admin-api/system/role/save`, param);
};

export const updateRole = async (param: any) => {
  return await POST(`/admin-api/system/role/update`, param);
};

export const queryMenuIdsByRoleId = async (params: any) => {
  return await GET(`/admin-api/system/menu/queryMenuIdsByRoleId`, { params });
};

export const upgradeRoleMenuPermission = async (param: any) => {
  return await POST(`/admin-api/system/menu/upgradeRoleMenuPermission`, param);
};

export const removeRole = async (id: any) => {
  return await GET(`/admin-api/system/role/remove/${id}`);
};

export const getMenu = async () => {
  return await POST(`/admin-api/system/menu/list`);
};

export const queryQuotasIdsByRoleId = async (params: any) => {
  return await GET(`/admin-api/system/quotas/queryRoleQuotasByRoleId`, { params });
};

export const upgradeRoleQuotasPermission = async (param: any) => {
  return await POST(`/admin-api/system/quotas/upgradeRoleQuotasPermission`, param);
};

export const getAnalysisRecord = async (data: any, params: any) => {
  return await POST(`/tracking-api/analysis/listPage`, data, { params });
};

export const downloadAnalysisRecord = async (data: any) => {
  return await POST(`/tracking-api/analysis/exportEventList?${new URLSearchParams(data).toString()}`, data, { responseType: "blob" });
};

export const getAnalysisStatistics = async (params: any) => {
  return await POST(`/tracking-api/analysis/statPageEventCount`, undefined, { params });
};

export const downloadAnalysisStatistics = async (data: any) => {
  return await POST(`/tracking-api/analysis/exportEventStatistic?${new URLSearchParams(data).toString()}`, data, { responseType: "blob" });
};

export const layerStatistics = async (data: any) => {
  // return await POST(`/tracking-api/analysis/trackEvent`, data);
  return await POST(`/tracking-api/analysis/track`, data);
};

export const getRiskAnalysis = async (params: any, signal?: AbortSignal) => {
  return await GET(`/singlesite-api/riskAnalysis/analysis`, { params, signal });
};

export const getLayerCounter = async (params: any, data: any) => {
  return await POST(`/singlesite-api/riskAnalysis/queryItemCounter`, data, { params });
}

export const getLineCounter = async (params: any, data: any) => {
  return await POST(`/polyanalysis-api/linear/queryItemCounter`, data, { params });
}

export const getPolygonCounter = async (params: any, data: any) => {
  return await POST(`/polyanalysis-api/zonal/queryItemCounter`, data, { params });
}

export const getLocationValidateItemCounter = async (data: any) => {
  return await POST(`/locationset-api/asyncBatchJob/validateItemCounter`, data);
};

export const getSingleValidateItemCounter = async (data: any) => {
  return await POST(`/singlesite-api/riskAnalysis/validateItemCounter`, data);
};

export const getLineValidateItemCounter = async (data: any) => {
  return await POST(`/polyanalysis-api/linear/validateItemCounter`, data);
};

export const getPolygonValidateItemCounter = async (data: any) => {
  return await POST(`/polyanalysis-api/zonal/validateItemCounter`, data);
};

export const getQuotasStatistic = async (params: any) => {
  return await POST(`/admin-api/system/tenantQuotas/statPageTenantQuotasCount`, undefined, { params });
};

export const downloadQuotasStatistic = async (data: any) => {
  return await POST(`/admin-api/system/tenantQuotas/exportTenantQuotasStatistic?${new URLSearchParams(data).toString()}`, data, { responseType: "blob" });
};

export const getEventList = async (params: any) => {
  return await GET(`/risklayer-api/catnet/events`, { params });
};

export const getEventDetail = async (eventId: string) => {
  return await GET(`/risklayer-api/catnet/events/${eventId}/details?includeTcTracks=true`);
};

export const clearTenantUseCount = async (params: any) => {
  return await GET(`/admin-api/system/tenantQuotas/clearTenantUseCount`, { params });
};

export const getEventsLegends = async (params: any) => {
  return await GET(`/risklayer-api/proxy/catnet/legends`, { params });
}

export const getRiskAnalysisEvent = async (params: any) => {
  return await GET(`singlesite-api/riskAnalysis/analysisEvent`, { params });
};

export const getEndPoint = async (param: any, pageParam: any) => {
  return await POST(`/prap-api/auth/manage/endpoint/listPage`, param, { params: pageParam });
};

export const getEndPointList = async () => {
  return await POST(`/prap-api/auth/manage/endpoint/list`);
};

export const addEndPoint = async (param: any) => {
  return await POST(`/prap-api/auth/manage/endpoint/save`, param);
};

export const updateEndPoint = async (param: any) => {
  return await POST(`/prap-api/auth/manage/endpoint/update`, param);
};

export const removeEndPoint = async (id: any) => {
  return await GET(`/prap-api/auth/manage/endpoint/removeById?id=${id}`);
};

export const getApiClient = async (param: any, pageParam: any) => {
  return await POST(`/prap-api/auth/manage/apiClient/listPage`, param, { params: pageParam });
};

export const addClient = async (param: any) => {
  return await POST(`/prap-api/auth/manage/apiClient/saveUpdate`, param);
};

export const removeClients = async (ids: any) => {
  return await GET(`/prap-api/auth/manage/apiClient/deleteClient?ids=${ids}`);
};

export const getApiKey = async (param: any, pageParam: any) => {
  return await POST(`/prap-api/auth/manage/apiKey/listPage`, param, { params: pageParam });
};

export const addKey = async (param: any) => {
  return await POST(`/prap-api/auth/manage/apiKey/create`, param);
};

export const updateKey = async (param: any) => {
  return await POST(`/prap-api/auth/manage/apiKey/update`, param);
};

export const removeKeys = async (ids: any) => {
  return await GET(`/prap-api/auth/manage/apiKey/delete?ids=${ids}`);
};

export const getApiGroup = async (param: any, pageParam: any) => {
  return await POST(`/prap-api/auth/manage/apiGroup/listPage`, param, { params: pageParam });
};

export const addGroup = async (param: any) => {
  return await POST(`/prap-api/auth/manage/apiGroup/saveUpdate`, param);
};

export const removeGroups = async (ids: any) => {
  return await GET(`/prap-api/auth/manage/apiGroup/deleteGroup?id=${ids}`);
};

export const getApiScope = async (param: any, pageParam: any) => {
  return await POST(`/prap-api/auth/manage/apiScope/listPage`, param, { params: pageParam });
};

export const addScope = async (param: any) => {
  return await POST(`/prap-api/auth/manage/apiScope/saveUpdate`, param);
};

export const removeScopes = async (ids: any) => {
  return await GET(`/prap-api/auth/manage/apiScope/deleteScope?ids=${ids}`);
};

export const getKeyScopeById = async (id: any) => {
  return await GET(`/prap-api/auth/quotas/manage/getScopeAndAllScopeByKeyId/${id}`);
};

export const updateKeyScopeQuota = async (param: any) => {
  return await POST(`/prap-api/auth/quotas/manage/updateQuota`, param);
};

export const createNotification = async (param: {
  notificationType: string;
  notificationMessage: string;
  releaseId?: number;
  releaseVersion?: string;
  startTime?: string;
  expirationTime?: string;
  noExpirationTime: boolean;
  isBanner: boolean;
  isRing: boolean;
  status: "draft" | "publish";
}) => {
  return await POST(`/message-api/admin/notification/new`, param);
};

export const updateNotification = async (param: {
  notificationId: string | number;
  notificationType: string;
  notificationMessage: string;
  releaseId?: number;
  releaseVersion?: string;
  startTime?: string;
  expirationTime?: string;
  createTime?: string;
  noExpirationTime: boolean;
  isBanner: boolean;
  isRing: boolean;
  status: "draft" | "publish";
}) => {
  return await PUT(`/message-api/admin/notification/update`, param);
};

export const deleteNotification = async (notificationId: string | number) => {
  return await PUT(
    `/message-api/admin/notification/delete?notificationId=${notificationId}`
  );
};

export const getNotificationList = async (param: any, pageParam?: any) => {
  return await POST(`/message-api/admin/notification/list`, param, { params: pageParam });
};

export const createResource = async (param: {
  resourceType: string;
  resourceVersion: string;
  resourceTitle: string;
  resourceContent: string;
  attachments?: string[];
  status: "draft" | "publish";
}) => {
  return await POST(`/message-api/admin/resource/new`, param);
};

export const updateResource = async (param: {
  resourceId: number;
  resourceType: string;
  resourceVersion: string;
  resourceTitle: string;
  resourceContent: string;
  attachments?: string[];
  status: "draft" | "publish";
}) => {
  return await PUT(`/message-api/admin/resource/update`, param);
};

export const deleteResource = async (resourceId: number) => {
  return await PUT(
    `/message-api/admin/resource/delete?resourceId=${resourceId}`
  );
};

export const getResourceList = async (param: any = { keyword: "" }) => {
  return await POST(`/message-api/admin/resource/list`, param);
};

export const uploadResourceFiles = async (formData: FormData) => {
  return await POST(`/message-api/admin/resource/upload_files`, formData);
};

export const getUserNotifications = async () => {
  return await GET(`/message-api/notification/get`);
};

export const updateUserNotifications = async (params: any) => {
  return await POST(`/message-api/notification/update`, params);
};

export const getReleaseNote = async (params: any) => {
  return await GET(`/message-api/notification/release_note`, { params });
};

export const getResourceNote = async (resourceType: string, keyword: string = "") => {
  return await POST(`/message-api/notification/resource_note`, { keyword }, {
    params: { resourceType },
  });
};

export const getResourceFile = async (filePath: string) => {
  return await GET(`/message-api/notification/resources`, {
    params: { filePath },
  });
};

export const getConfigDictionary = async (categoryKey: string) => {
  return await GET(`/message-api/common/config`, {
    params: { categoryKey },
  });
};

export const getBill = async (param: any, pageParam: any) => {
  return await POST(`/prap-api/auth/manage/apiBill/listPage`, param, { params: pageParam });
};

export const addBill = async (param: any) => {
  return await POST(`/prap-api/auth/manage/apiBill/saveUpdate`, param);
};

export const removeBills = async (ids: any) => {
  return await GET(`/prap-api/auth/manage/apiBill/delete?ids=${ids}`);
};

export const getByClientBill = async (ids: any) => {
  return await GET(`/prap-api/auth/manage/apiKey/listByClientBill?clientId=${ids}`);
};

export const getTrackEvent = async (data: any, params: any) => {
  return await POST(`/prap-api/tracking/event/listPage`, data, { params });
};

export const downloadEventList = async (data: any) => {
  return await POST(`/prap-api/tracking/event/exportEventList?${new URLSearchParams(data).toString()}`, data, { responseType: "blob" });
};

export const getSummary = async (data: any, params: any) => {
  return await POST(`/prap-api/auth/manage/apiBill/summary`, data, { params });
};

export const exportSummaryList = async (data: any) => {
  return await POST(`/prap-api/auth/manage/apiBill/exportSummaryList?${new URLSearchParams(data).toString()}`, data, { responseType: "blob" });
};

export const getUsageSummary = async (data: any, params: any) => {
  return await POST(`/prap-api/auth/manage/apiBill/usageSummary`, data, { params });
};

export const exportUsageSummary = async (data: any) => {
  return await POST(`/prap-api/auth/manage/apiBill/exportUsageSummary?${new URLSearchParams(data).toString()}`, data, { responseType: "blob" });
};

export const startLineAnalysis = async (data: any) => {
  return await POST(`/polyanalysis-api/linear/analysisAsync`, data);
};

export const startPolygonAnalysis = async (data: any) => {
  return await POST(`/polyanalysis-api/zonal/analysisAsync`, data);
};

export const getLineAnalysisStatus = async (jobId: string) => {
  return await GET(`/polyanalysis-api/linear/checkStatus/${jobId}`);
};

export const getLineAnalysisResult = async (jobId: string) => {
  return await GET(`/polyanalysis-api/linear/analysisAsyncResult/${jobId}`);
};

export const getPolygonAnalysisStatus = async (jobId: string) => {
  return await GET(`/polyanalysis-api/zonal/checkStatus/${jobId}`);
};

export const getPolygonAnalysisResult = async (jobId: string) => {
  return await GET(`/polyanalysis-api/zonal/analysisAsyncResult/${jobId}`);
};